import { defineDeckPassive } from '../authoring/index.js';
const COPIED_ROUND_VAR = 'copiedRound';
function candidateCells(ctx, playerId, tableId) {
    const side = ctx.q.player(playerId).side;
    return [0, 1, 2].flatMap((laneIndex) => {
        const cellId = `T${tableId}-L${laneIndex}-${side}`;
        const cell = ctx.q.cell(cellId);
        return cell?.occupantId === null
            && !ctx.q.isCellReserved(cellId)
            && !ctx.q.hasStagedFieldInCell(playerId, cellId)
            ? [cellId]
            : [];
    });
}
function candidateLocations(ctx, playerId, sourceTableId) {
    return [0, 1, 2].filter((tableId) => tableId !== sourceTableId
        && candidateCells(ctx, playerId, tableId).length > 0);
}
export const EchoingDeploymentPassive = defineDeckPassive({
    id: 'echoing_deployment',
    role: 'available',
    presentation: {
        name: 'Эхо развёртывания',
        description: 'Первая ваша полевая карта за раунд создаёт свою копию 1/1 в случайной другой локации.',
        glyph: {
            colors: ['#10213A', '#59AAE2', '#4A95CF', '#4A95CF', '#4A95CF'],
            rows: [
                '....................',
                '....................',
                '......111111........',
                '.....12222221.......',
                '...11222222221......',
                '..1222222222221.....',
                '..1222222222221.....',
                '..12222222222221....',
                '..12211222112221....',
                '.122211222112221....',
                '.122222222222231....',
                '12222222222223331...',
                '122222222222233311..',
                '1332222222223331221.',
                '13332222223333122221',
                '13333333333331212121',
                '13333333333331222231',
                '.1333333333331322331',
                '.1333333333331333331',
                '..11111111111111111.',
            ],
        },
    },
    initialEffect: {
        vars: { [COPIED_ROUND_VAR]: 0 },
    },
    hooks: {
        onAnyEvent(ctx, event) {
            const effect = ctx.effect;
            if (effect?.scope.kind !== 'player')
                return;
            const playerId = effect.scope.playerId;
            // UnitAppeared follows the card's own appearance cascade, but is still
            // resolved before the next committed FIELD card is revealed.
            if (event.type !== 'UnitAppeared' || event.cause !== 'played'
                || event.controllerId !== playerId || effect.vars[COPIED_ROUND_VAR] === ctx.round)
                return;
            const source = ctx.q.instance(event.instanceId);
            if (source?.zone !== 'board' || source.cellId === undefined
                || source.isToken || source.controllerId !== playerId)
                return;
            ctx.ops.setVar(COPIED_ROUND_VAR, ctx.round);
            const sourceCell = ctx.q.cell(source.cellId);
            if (sourceCell === null)
                return;
            const candidates = candidateLocations(ctx, playerId, sourceCell.tableId);
            if (candidates.length === 0)
                return;
            const tableId = ctx.rng.pick(candidates);
            const targetCellId = candidateCells(ctx, playerId, tableId)[0];
            if (targetCellId === undefined)
                return;
            ctx.ops.tryCreateToken(source.defId, playerId, targetCellId, { attack: 1, health: 1 });
        },
    },
});
//# sourceMappingURL=echoing_deployment.js.map